// File: src/utils/efficiencyCalculator.js

// Helper function to extract the sprint number
const getSprintNum = (name) => {
  const match = name.match(/\d+/);
  return match ? parseInt(match[0], 10) : 0;
};

export const calculateEfficiencyMetrics = (items) => {
  let totalScore = 0;
  let scoredItemsCount = 0;
  const sprintData = {};

  items.forEach(item => {
    const sprint = item.sprintName || "Unassigned Sprint";
    
    // 🔥 1. ALWAYS initialize the sprint so it guarantees a spot in the UI
    if (!sprintData[sprint]) {
      sprintData[sprint] = { totalScore: 0, count: 0 };
    }

    // 2. Only add to the math if the item actually has an efficiency score
    if (item.efficiencyScore !== null && item.efficiencyScore !== undefined) {
      // Global Project Tracking
      totalScore += item.efficiencyScore;
      scoredItemsCount++;

      // Sprint-Level Tracking
      sprintData[sprint].totalScore += item.efficiencyScore;
      sprintData[sprint].count++;
    }
  });

  const overallEfficiency = scoredItemsCount > 0
    ? Math.round((totalScore / scoredItemsCount) * 10)
    : null;

  const sprintEfficiencyList = Object.entries(sprintData)
    .map(([name, data]) => ({
      name,
      // 🔥 3. Safely calculate percentage. If count is 0, default to 0% to avoid NaN.
      count: data.count > 0 ? Math.round((data.totalScore / data.count) * 10) : 0 
    }))
    .sort((a, b) => getSprintNum(b.name) - getSprintNum(a.name));

  // Group the list by sprint prefix (Case-Insensitive)
  const groupedSprintEfficiency = {};
  
  sprintEfficiencyList.forEach(sprint => {
    // Extracts the first alphabetical word from the name
    const match = sprint.name.match(/^[A-Za-z]+/);
    const rawType = match ? match[0] : "Other";

    const type = rawType.charAt(0).toUpperCase() + rawType.slice(1).toLowerCase();

    if (!groupedSprintEfficiency[type]) {
      groupedSprintEfficiency[type] = [];
    }
    groupedSprintEfficiency[type].push(sprint);
  });

  return {
    overallEfficiency,
    sprintEfficiencyList,
    groupedSprintEfficiency
  };
};